import { addScrollEventListener } from "../plugins/scrolldetect";

/**
 *
 * @namespace scrollDetects
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/manager/scrollDetects.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

/**
 * @function scrollDetects.addScrollEventListener
*/
addScrollEventListener(function(data){
  if (data.el.id === 'scrolldetectmain'){
    const aside = document.querySelector('.l-defaultlayout__aside')
    if (aside) aside.style.position = data.direction === 'down' ? 'fixed' : 'static'
  }
})